import { Box, Paper } from "@mui/material";
import CheckLoading from "../CheckLoading";
import { LoadStateInfo } from "../../../redux/common";
import PrizaGridBar from "./PrizaGridBar";

export interface Buttons {
    label: React.ReactNode;
    click: () => void;
}

export interface PrizaAvatarGridProps {
    content: () => React.ReactNode;
    state: LoadStateInfo;
    retry?: () => void;
    toolbar: {
        label: React.ReactNode;
        buttons?: Buttons[];
        position?: "top" | "bottom" | undefined;
    }
    messages: {
        empty: string;
        error: string;
    }
    notStarted?: React.ReactNode;
}

const PrizaContainer = ({ content, state, retry, toolbar, messages, notStarted, }: PrizaAvatarGridProps) => {
    const elToolbar = <PrizaGridBar toolbar={toolbar} retry={retry} />;
    return <Paper sx={{ width: "100%", minWidth: "300px" }} elevation={3}>
        {toolbar.position != "bottom" ? elToolbar : undefined}
        <Box display={"flex"} width="100%">
            <CheckLoading
                states={[state]}
                error={messages.error}
                content={content}
                notStarted={notStarted}
                retry={retry} />
        </Box>
        {toolbar.position == "bottom" ? elToolbar : undefined}
    </Paper>;
};

export default PrizaContainer;